<template>
    <div class="container mx-md-5 pb-4">
        <h5 class="text-white mt-4">
            Blog
        </h5>

        <h5 class="text-white text-center text-muted">Coming Soon</h5>
        <br>
        <div style="position: absolute;width: 100%;" >
           
            <div class="row" style="width: 100%;"  >
                <div class="col-md-4 offset-md-4 mt-5 pt-5">
                <RocketAnimation />
                </div>
            </div>
        </div>

        <img src="https://raw.githubusercontent.com/ShineShineDev/ShineShineDev/55f9002887e4a0cbb513502045b1734b2f2fbe67/imgs/mainIconsdark.svg"
            class="js-img" />
    </div>
</template>
<script>
import Pending from "./../components/Pending.vue";
import RocketAnimation from "./../components/RocketAnimation.vue";
import {InitBrowserAgent} from "./../services/detech-visitors.js";
export default {
    name: "Project",
    data() {
        return {
            loadingStatus: true,
            projects: [],
            showAll: [],
            expandedProjects: {},
            host: process.env.VUE_APP_HOST,
        };
    },
    components: {
        Pending,
        RocketAnimation
    },
    created() {
        const {browser,language,platform,innerWidth,innerHeight,URL,visitor_generated__id,is_new_visitor,outerWidth,outerHeight,referrer} = InitBrowserAgent(); 
        this.$store.dispatch('initApi', { url: 'https://bot.okjapanstore.com/api/tg/notify', method: 'POST', data: { Noti: 'Alert',URL,browser,language,platform,innerWidth,innerHeight,visitor_generated__id , is_new_visitor,innerWidth,innerHeight,outerWidth,outerHeight,referrer} });
        fetch('https://raw.githubusercontent.com/ShineShineDev/ShineShineDev/refs/heads/main/data.json')
            .then(response => {
                if (!response.ok) {
                    throw new Error('Network response was not ok');
                }
                return response.json();
            })
            .then(data => {
                this.projects = data;
                this.showAll = Array(data.length).fill(false);
                console.log(this.showAll);
                this.loadingStatus = false
            })
            .catch(error => {
                console.error('There was a problem with the fetch operation:', error);
            });
    },
    methods: {
        toggleExpand(index) {
            this.$set(this.expandedProjects, index, !this.expandedProjects[index]);
        },
        getDisplayText(project, index) {
            const html = project.lists || '';
            if (this.expandedProjects[index]) {
                return html;
            }
            const tempDiv = document.createElement('div');
            tempDiv.innerHTML = html;
            const textOnly = tempDiv.textContent || tempDiv.innerText || '';
            return textOnly.length > 150
                ? textOnly.substring(0, 150) + '...'
                : textOnly;
        }
    }
};
</script>

<style scoped>
.border-line {
    border-radius: 50%;
    border-bottom: 2px solid #FF4A01;

    border-radius: 0 0 20px 20px;
}

.card__arc path {
    top: 0;
    fill: white;
    d: path("M 40 80 c 22 0 40 -22 40 -40 v 40 Z");
}

.card__arrow {
    position: absolute;
    background: #df8218;
    border-radius: 0px 30px 0px 100px;
    right: 0;
    font-size: 19px;
    color: white;
    transition: 0.2s;
}

.shine-divider {
    margin-top: 5px;
    margin-bottom: 3px;
    border: 0px;
    height: 3px;
    background: linear-gradient(to right, rgba(157, 157, 157, 0), #ec4e10, rgba(0, 0, 0, 0));
    background-size: 200% 100%;
    animation: shineAnimation 1.5s infinite alternate;
}

@keyframes shineAnimation {
    0% {
        background-position: 100% 50%;
    }

    100% {
        background-position: 0 50%;
    }
}

.js-img {
    position: fixed;
    bottom: 0%;
    left: 80%;

    width: 400px;

}
</style>